import React, { useCallback, memo, Fragment } from 'react';
import PropTypes from 'prop-types';

const RadioInput = ({
    label,
    values,
    onChange,
    name,
    options,
    errors = {},
    touched = {},
}) => {
    const renderError = useCallback(
        () =>
            touched[name] &&
            errors[name] && <p className="c-error-message">*{errors[name]}</p>,
        [errors, name, touched]
    );
    const renderOptions = useCallback(() => {
        return options.map((option, i) => (
            <span className="o-inline-group__item" key={`${option.label}${i}`}>
                <label className="c-checkbox">
                    <input
                        className="c-radio__input"
                        type="radio"
                        name={name}
                        checked={
                            values[name] !== null &&
                            values[name] === option.value
                        }
                        onChange={() => onChange(name, option.value)}
                    />
                    <span className="c-radio__label">{option.label}</span>
                </label>
            </span>
        ));
    }, [name, onChange, options, values]);

    const ViewTitle = () => {
        if (label === '') {
            return label;
        } else {
            return (
                <div className="c-accordion__header js-accordion__title c-vehicle-filters__item-title">
                    <span className="c-accordion__title"></span>
                    <h3 className="c-accordion__title">
                        <button
                            className="c-accordion__title-label js-accordion__title-label"
                            aria-expanded="true"
                            type="button"
                        >
                            <label
                                htmlFor={name}
                                className="c-accordion__title-label-text "
                            >
                                {label}
                            </label>
                        </button>
                    </h3>
                </div>
            );
        }
    };
    return (
        <Fragment>
            <ViewTitle />

            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content"
                aria-hidden="false"
            >
                <div
                    className={
                        'c-accordion__content c-vehicle-filters__' + name
                    }
                >
                    {renderOptions()}
                </div>
                {renderError()}
            </div>
        </Fragment>
    );
};

RadioInput.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    errors: PropTypes.object,
    touched: PropTypes.object,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    values: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default memo(RadioInput);
